export default {
  brandColor1: '#13202C',
  complimentaryColor1: '#fff',
  brandColor2: '#13202C',
  complimentaryColor2: '#fff',
};
